<script>
  // Jobs that finished cleanly.
  import JobList from "./JobList.svelte";
  import SolvedCard from "../FileCard/SolvedCard.svelte";
</script>

<JobList
  url="/file/solved"
  title="Solved"
  emptyMessage="No solved jobs yet"
  emptyHint="Jobs appear here once their script exits cleanly."
  emptyIcon="fa-check-circle"
  let:file
  let:refresh
>
  <SolvedCard
    fileId={file.id}
    filename={file.file_name}
    uploadedDateTime={file.upload_date}
    solvedDateTime={file.solved_date}
    on:changed={refresh}
  />
</JobList>
